import {
  Autocomplete,
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  Checkbox,
  Chip,
  Container,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Slider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import variables from "../../../assets/styles/variables.module.scss";
import { useDispatch } from "react-redux";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { GET_AGENT, GET_MODELS_LIST, GET_PROMPTS, GET_TEMPLATE, UPDATE_AGENT, UPDATE_TEMPLATE } from "../../../Services/Endpoint";
import MetaInstance from "../../../Services/AxiosInstance/MetaInstance";
import { ShowError, ShowSuccess } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import { NotSelected } from "../../../Constant/Setting";
import { Params, useParams } from "react-router-dom";
import OldAgent from "../../../Shared-ui/Types/OldAgent";
import FormOne from "./FormOne";
import FormTwo from "./FormTwo";
import { Prompt } from "../../../Shared-ui/Types/common";
import Template from "../../../Shared-ui/Types/Template";


const AiSettings = (props: any) => {


  const [activeTab, setActiveTab] = useState("first"); // State to track the active tab
  const [knowledgeBase, setknowledgeBase] = useState<OldAgent>()
  const { agentId } = useParams<Params>();
  const { templateId } = useParams<Params>();
  const dispatch = useDispatch()
  const [prompts, setPrompts] = useState<Prompt[]>([])

  const pathname = window.location.pathname;
  const basePath = pathname.split('/').slice(0, -1).join('/');

  useEffect(() => {
    const fetchData = async () => {
      await getknowledgeBase()
      // await getPrompts()
    }
    fetchData()
  }, [])

  const getknowledgeBase = async () => {
    try {
      dispatch(StartLoading())
      if (basePath === "/template") {
        const data = await MetaInstance.get(`${GET_TEMPLATE}/${props.template.id}`).then(res => res?.data?.detail);
        setknowledgeBase(data.response)
      } else {
        const data = await MetaInstance.get(`${GET_AGENT}/${agentId}`).then(res => res?.data?.detail);
        setknowledgeBase(data.response)
      }


    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response))
    } finally {
      dispatch(StopLoading())

    }
  }

  useEffect(() => {
    if (!knowledgeBase) {
      getknowledgeBase();
    }
  }, []);

  const updateknowledgeBase = async () => {
    try {
      dispatch(StartLoading());

      const updatedData = knowledgeBase; // Keep existing state

      if (basePath === "/template") {
        await MetaInstance.put(`${UPDATE_TEMPLATE}/${templateId}`, updatedData);
      } else {
        await MetaInstance.put(`${UPDATE_AGENT}/${agentId}`, updatedData);
      }

      dispatch(ShowSuccess("Updated successfully"));
      let newData: { response: OldAgent | Template; }

      if (basePath !== "/template") {
        newData = await MetaInstance.get(`${GET_AGENT}/${agentId}`).then(res => res?.data?.detail);
      } else {
        newData = await MetaInstance.get(`${GET_TEMPLATE}/${templateId}`).then(res => res?.data?.detail);
      }
      // Fetch the latest data but preserve existing prompts
      // const newData = await MetaInstance.get(`${GET_AGENT}/${agentId}`).then(res => res?.data?.detail);

      setknowledgeBase((prev: any) => ({
        ...prev,
        ...newData.response,
        prompts: prev.prompts, // Preserve selected prompts
      }));

    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response));
    } finally {
      dispatch(StopLoading());
    }
  };


  const getPrompts = async () => {
    try {
      dispatch(StartLoading())
      const data = await MetaInstance.get(`${GET_PROMPTS}?page=${1}&limit=${1000}`).then(res => res?.data?.detail)
      setPrompts(data.response)
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response))
    } finally {
      dispatch(StopLoading())

    }
  }




  const handleTabChange = (tab: React.SetStateAction<string>) => {
    setActiveTab(tab);
  };




  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          mb: 3,
        }}
      >
        <ButtonGroup variant="outlined" aria-label="Basic button group">
          <Button
            variant={activeTab === "first" ? "contained" : "outlined"} // Apply styles based on active tab
            onClick={() => handleTabChange("first")}
            disableElevation
          >
            External API
          </Button>
          <Button
            disabled={true}
            variant={activeTab === "second" ? "contained" : "outlined"} // Apply styles based on active tab
            onClick={() => handleTabChange("second")}
            disableElevation
          >
            LLM Local MODELS
          </Button>
        </ButtonGroup>
      </Box>
      {activeTab === "first" && (
        <FormOne
          key={"first"}
          getknowledgeBase={getknowledgeBase}
          knowledgeBase={knowledgeBase}
          updateknowledgeBase={updateknowledgeBase}
          setknowledgeBase={setknowledgeBase} />
      )}




      {/* {activeTab === "second" && (
        <FormTwo
          getknowledgeBase={getknowledgeBase}
          knowledgeBase={knowledgeBase}
          updateknowledgeBase={updateknowledgeBase}
          setknowledgeBase={setknowledgeBase} 
          />
      )} */}
    </Box>
  );
};

export default AiSettings;
